"use client";
import Image from "next/image";
import { twMerge } from "tailwind-merge";
import { Gallery } from "@/app/(components)/Basic/Gallery";

export interface Props {
  images: string[];
}

const ArtOrderGallery = ({ images }: Props) => {
  return (
    <Gallery className="flex flex-wrap gap-2">
      {images.map((image, index) => (
        <span
          data-src={image}
          key={index}
          className={twMerge(
            "relative aspect-square hover:cursor-pointer",
            index === images.length - 1 && images.length % 2 === 1
              ? "w-full"
              : "w-[calc(50%-4px)]",
          )}
        >
          <Image
            src={image}
            alt="inspiration image"
            fill
            className="object-cover"
          />
        </span>
      ))}
    </Gallery>
  );
};

export default ArtOrderGallery;
